<clare-main-content-container [isNavNeeded]="false" [class.edit-customer-modal]="editCustomerPage">
    <ng-container mainContent>
        <div *letVar="customer$ | async as customer">
            <header mat-dialog-title>
                <a class="back-button href-btn" fxHide.lt-md (click)="cancel()">&lt; Back</a>
                <h1 mat-dialog-title>Edit Customer</h1>
            </header>
            <form [formGroup]="customerForm" (ngSubmit)="saveCustomer()" *ngIf="entities$ | async as entities">
                <mat-card [class.no-padding]="editCustomerPage">
                    <ng-container *ngIf="!isUserLoading; else loading">
                        <mat-card-content>
                            <div
                                mat-dialog-content
                                class="customer-info customerContainer"
                                [class.standalone-comp]="isStandalone"
                                [class.edit-user]="editCustomerPage"
                            >
                                <div class="block-info">
                                    <h2>Customer Info</h2>
                                    <p>
                                        <mat-form-field appearance="outline" *letVar="fields.firstName as field">
                                            <mat-label>First Name</mat-label>
                                            <input
                                                matInput
                                                id="firstName"
                                                type="text"
                                                placeholder="First Name"
                                                formControlName="firstName"
                                                required
                                                [errorStateMatcher]="errorMatcher"
                                            />
                                            <mat-error>
                                                <app-validation-message
                                                    [touched]="field.touched"
                                                    [errors]="field.errors"
                                                ></app-validation-message>
                                            </mat-error>
                                        </mat-form-field>
                                    </p>
                                    <p>
                                        <mat-form-field appearance="outline" *letVar="fields.lastName as field">
                                            <mat-label>Last Name</mat-label>
                                            <input
                                                matInput
                                                id="lastName"
                                                type="text"
                                                placeholder="Last Name"
                                                formControlName="lastName"
                                                required
                                                [errorStateMatcher]="errorMatcher"
                                            />
                                            <mat-error>
                                                <app-validation-message
                                                    [touched]="field.touched"
                                                    [errors]="field.errors"
                                                ></app-validation-message>
                                            </mat-error>
                                        </mat-form-field>
                                    </p>
                                    <p>
                                        <mat-form-field appearance="outline" *letVar="fields.email as field">
                                            <mat-label>Email</mat-label>
                                            <input
                                                matInput
                                                id="email"
                                                type="email"
                                                lowercase-inp
                                                placeholder="Email"
                                                formControlName="email"
                                                required
                                                [errorStateMatcher]="errorMatcher"
                                            />
                                            <mat-hint>Cannot be changed after the user login is created</mat-hint>
                                            <mat-error>
                                                <app-validation-message
                                                    [touched]="field.touched"
                                                    [errors]="field.errors"
                                                ></app-validation-message>
                                            </mat-error>
                                        </mat-form-field>
                                    </p>
                                    <p>
                                        <phone-input
                                            class="phone-field"
                                            label="Phone Number"
                                            field="phone"
                                            [theForm]="customerForm"
                                            notRequired="true"
                                        ></phone-input>
                                        <mat-form-field class="phone-field" appearance="outline">
                                            <mat-label>Phone Number Type</mat-label>
                                            <select
                                                matNativeControl
                                                id="phoneType"
                                                formControlName="phoneType"
                                                placeholder="-- Select phone type --"
                                                [errorStateMatcher]="errorMatcher"
                                            >
                                                <option *ngFor="let type of phoneTypeList" [value]="type">{{ type }}</option>
                                            </select>
                                        </mat-form-field>
                                    </p>
                                    <p *ngIf="showPhone2 || !editCustomerPage">
                                        <phone-input
                                            label="Phone Number 2"
                                            field="phone2"
                                            [theForm]="customerForm"
                                            notRequired="true"
                                        ></phone-input>
                                        <mat-form-field class="phone-field" appearance="outline">
                                            <mat-label>Phone Number 2 Type</mat-label>
                                            <select
                                                matNativeControl
                                                id="phoneType"
                                                formControlName="phone2Type"
                                                placeholder="-- Select phone 2 type --"
                                                [errorStateMatcher]="errorMatcher"
                                            >
                                                <option *ngFor="let type of phoneTypeList" [value]="type">{{ type }}</option>
                                            </select>
                                        </mat-form-field>
                                    </p>
                                    <p *ngIf="showPhone3 || !editCustomerPage">
                                        <phone-input
                                            label="Phone Number 3"
                                            field="phone3"
                                            [theForm]="customerForm"
                                            notRequired="true"
                                        ></phone-input>
                                        <mat-form-field class="phone-field" appearance="outline">
                                            <mat-label>Phone Number 3 Type</mat-label>
                                            <select
                                                matNativeControl
                                                id="phoneType"
                                                formControlName="phone3Type"
                                                placeholder="-- Select phone 3 type --"
                                                [errorStateMatcher]="errorMatcher"
                                            >
                                                <option *ngFor="let type of phoneTypeList" [value]="type">{{ type }}</option>
                                            </select>
                                        </mat-form-field>
                                    </p>
                                    <div *ngIf="editCustomerPage && !showPhone3">
                                        <a class="additional-phone" mat-flat-button (click)="addMorePhone()">
                                            <div style="text-align: center">
                                                <span style="margin-right: 0.25rem">+</span>
                                                <span>Additional Phone Number</span>
                                            </div>
                                        </a>
                                    </div>
                                    <div *ngIf="editCustomerPage" class="customer-action">
                                        <div *ngxPermissionsOnly="['transferCustomer']">
                                            <h2>Customer Actions</h2>
                                            <p>
                                                <mat-form-field appearance="outline" *letVar="fields.entityId as field">
                                                    <mat-label>Transfer Ownership</mat-label>
                                                    <select
                                                        matNativeControl
                                                        id="entityId"
                                                        formControlName="entityId"
                                                        required
                                                        [errorStateMatcher]="errorMatcher"
                                                    >
                                                        <option *ngFor="let entity of entities" [value]="entity.id">
                                                            {{ entity.name }}
                                                        </option>
                                                    </select>
                                                    <mat-error>
                                                        <app-validation-message
                                                            [touched]="field.touched"
                                                            [errors]="field.errors"
                                                        ></app-validation-message>
                                                    </mat-error>
                                                </mat-form-field>
                                            </p>
                                            <p *ngIf="userRoles$ | async as userRoles">
                                                <mat-form-field appearance="outline" *letVar="fields.roleId as field">
                                                    <mat-label>Convert to User</mat-label>
                                                    <select
                                                        matNativeControl
                                                        id="roleId"
                                                        formControlName="roleId"
                                                        required
                                                        [errorStateMatcher]="errorMatcher"
                                                    >
                                                        <option *ngFor="let role of userRoles" [value]="role.id">{{ role.name }}</option>
                                                    </select>
                                                    <mat-error>
                                                        <app-validation-message
                                                            [touched]="field.touched"
                                                            [errors]="field.errors"
                                                        ></app-validation-message>
                                                    </mat-error>
                                                </mat-form-field>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="!editCustomerPage">
                                    <div class="block-info" *ngxPermissionsOnly="['transferCustomer']">
                                        <h2>Customer Actions</h2>
                                        <p>
                                            <mat-form-field appearance="outline" *letVar="fields.entityId as field">
                                                <mat-label>Transfer Ownership</mat-label>
                                                <select
                                                    matNativeControl
                                                    id="entityId"
                                                    formControlName="entityId"
                                                    required
                                                    [errorStateMatcher]="errorMatcher"
                                                >
                                                    <option *ngFor="let entity of entities" [value]="entity.id">{{ entity.name }}</option>
                                                </select>
                                                <mat-error>
                                                    <app-validation-message
                                                        [touched]="field.touched"
                                                        [errors]="field.errors"
                                                    ></app-validation-message>
                                                </mat-error>
                                            </mat-form-field>
                                        </p>
                                        <p *ngIf="userRoles$ | async as userRoles">
                                            <mat-form-field appearance="outline" *letVar="fields.roleId as field">
                                                <mat-label>Convert to User</mat-label>
                                                <select
                                                    matNativeControl
                                                    id="roleId"
                                                    formControlName="roleId"
                                                    required
                                                    [errorStateMatcher]="errorMatcher"
                                                >
                                                    <option *ngFor="let role of userRoles" [value]="role.id">{{ role.name }}</option>
                                                </select>
                                                <mat-error>
                                                    <app-validation-message
                                                        [touched]="field.touched"
                                                        [errors]="field.errors"
                                                    ></app-validation-message>
                                                </mat-error>
                                            </mat-form-field>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </mat-card-content>
                        <mat-card-actions class="formActionButtonGroup mat-dialog-actions clearfix">
                            <a
                                mat-button
                                class="remove-customer-btn"
                                *ngIf="removeAction === 'remove'"
                                color="warn"
                                (click)="removeCustomer(customer)"
                                [id]="'deleteButton'"
                            >
                                Remove as Customer
                            </a>
                            <a
                                mat-button
                                class="remove-customer-btn"
                                *ngIf="removeAction === 'delete'"
                                color="warn"
                                (click)="deleteCustomer(customer)"
                                [id]="'deleteButton'"
                                >Delete</a
                            >
                            <a mat-stroked-button *ngIf="!hideCancelBtn" id="cancel" [disabled]="submitAttempted" (click)="cancel()">
                                Cancel
                            </a>
                            <button
                                mat-raised-button
                                color="primary"
                                [disabled]="isSaveDisabled"
                                class="edit-customer new-primary-button"
                                type="submit"
                            >
                                Save
                            </button>
                        </mat-card-actions>
                    </ng-container>
                </mat-card>
            </form>
        </div>
    </ng-container>
</clare-main-content-container>

<ng-template #loading>
    <clare-spinner text="Loading Customer Information"></clare-spinner>
</ng-template>
